module.exports = __webpack_public_path__ + "static/img/safecloth.ffd7f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/safecloth.png
// module id = 4Cbn
// module chunks = 21